module.exports = __webpack_public_path__ + "static/template_options_2_years-cd72b4e778fffb8f5a4d3d90f78badc2.png";